import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CancellationPolicy = () => {
  const [customContent, setCustomContent] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/settings`);
        if (res.data.cancellation_policy_content) {
          setCustomContent(res.data.cancellation_policy_content);
        }
      } catch (e) {
        console.error('Failed to fetch settings:', e);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div className="min-h-screen bg-[#f0f4f8]">
      <Navbar />
      
      <div className="pt-44 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-[#0a0203] mb-8">Cancellation Policy</h1>
          
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-lg max-w-none">
            <p className="text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
            
            {customContent ? (
              <div className="text-gray-600" dangerouslySetInnerHTML={{ __html: customContent }} />
            ) : (
              <>
                <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">Order Cancellation</h2>
                <p className="text-gray-600 mb-6">
                  At HomeLyph, we understand that circumstances can change. This policy outlines how you can cancel your order 
                  and what to expect during the cancellation process for customers in <strong>Canada</strong> and the <strong>United States</strong>.
                </p>

                <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">Before Shipment</h2>
                <p className="text-gray-600 mb-4">
                  Orders can be cancelled free of charge if the request is received before the item has shipped:
                </p>
                <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                  <li>Contact us immediately at <a href="mailto:info@peakprairie.ca" className="text-[#003456] hover:underline">info@peakprairie.ca</a></li>
                  <li>Include your order number in the subject line</li>
                  <li>Full refund will be processed within 5-7 business days</li>
                  <li>Refund will be issued to the original payment method</li>
                </ul>

                <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">After Shipment</h2>
                <p className="text-gray-600 mb-6">
                  Once an order has shipped, it cannot be cancelled. However, you may refuse delivery or return the item 
                  under our <Link to="/return-policy" className="text-[#003456] hover:underline">Return Policy</Link>. 
                  Return shipping costs may apply.
                </p>

                <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">Custom Orders</h2>
                <p className="text-gray-600 mb-6">
                  Custom or specially configured orders cannot be cancelled once production has begun. 
                  A 15% restocking fee may apply if cancellation is requested after order confirmation.
                </p>

                <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">Contact Us</h2>
                <p className="text-gray-600">
                  For cancellation requests, please contact us at:
                </p>
                <p className="text-gray-600 mt-2">
                  <strong>Email:</strong> <a href="mailto:info@peakprairie.ca" className="text-[#003456] hover:underline">info@peakprairie.ca</a><br />
                  <strong>Phone:</strong> 1-800-XXX-XXXX<br />
                  <strong>Hours:</strong> Monday - Friday, 9am - 5pm MST
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CancellationPolicy;
